import { Router } from '@angular/router';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/helpers/app.config';
import { Candidate } from 'src/app/models/candidate.model';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';

@Component({
  selector: 'ct-expired',
  templateUrl: './expired.component.html',
  styleUrls: ['./expired.component.scss']
})
export class ExpiredComponent implements OnInit {

  @Input() colors: any;

  public question$: Observable<Question>;
  public test$: Observable<Test>;

  public currentCandidate: Candidate;
  public currentLanguage: string;
  public currentTest: Test;
  public languagesNotSelected: string[];

  constructor(
    private store: Store,
    private router: Router
  ) { }

  ngOnInit(): void {
    // obtenemos los datos de la pregunta y el test de la store
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));
    this.test$ = this.store.pipe(select(fromTest.selectTestState));

    this.test$.subscribe(test => {
      if (test) {
        this.currentCandidate = test.candidate;
        this.currentTest = test;
      }
    });
  }

  public returnHome() {
    if (this.currentTest.invitation.origin === 'myrandstad') {
      location.href = AppConfig.settings.MYRANDSTAD + '/myrandstad/tests?navigation=finishedTests';
    } else {
      this.router.navigate(['candidate/home/' + this.currentTest.invitation.token], { queryParams: { testToken: this.currentTest.token } });
    }
  }

}

